import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpClient, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingstateService } from 'src/services/stateServices/loading/loadingstate.service';

@Injectable({
  providedIn: 'root'
})
export class HttploadingstateService implements HttpInterceptor {

  private readonly skipLoadingHeader = 'X-Skip-Loading';
  private _requests: HttpRequest<any>[] = [];
  constructor(private loadingState: LoadingstateService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(this.skipLoadingHeader)) {
      const requestWithoutLoadingHeader = req.clone({
        headers: req.headers.delete(this.skipLoadingHeader)
      });

      return next.handle(requestWithoutLoadingHeader);
    }

    this._requests.push(req);
    this.loadingState.changeLoading(true);
    var that = this;
    return next.handle(req).pipe(
      finalize(() => that.removeRequest(req))
    );
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this._requests.indexOf(req);
    if ( i >= 0) {
       this._requests.splice(i, 1);
    }
    this.loadingState.changeLoading(this._requests.length > 0);
  }
}